// @flow

import * as React from 'react';

import styles from './FeaturedVenueIcon.module.scss';

export default function SuperFeaturedVenueIcon(): React.Node {
  return (
    <div className={styles.icon}>
      <svg
        height="28"
        width="28"
        viewBox="0 0 30 30"
        preserveAspectRatio="xMinYMin meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{__('search.venue_preview.featured')}</title>
        <defs>
          <linearGradient x1="98.954%" y1="50%" x2="41.549%" y2="50%" id="a">
            <stop stopColor="#FFE" offset="0%" />
            <stop stopColor="#FFC" offset="100%" />
          </linearGradient>
          <linearGradient x1="100%" y1="50%" x2="0%" y2="50%" id="b">
            <stop stopColor="#F5EAA3" offset="0%" />
            <stop stopColor="#F5EBBD" offset="100%" />
          </linearGradient>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="c">
            <stop stopColor="#F4E3A5" offset="0%" />
            <stop stopColor="#D09F25" offset="100%" />
          </linearGradient>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="d">
            <stop stopColor="#E4C225" offset="0%" />
            <stop stopColor="#8F6D19" offset="100%" />
          </linearGradient>
          <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="e">
            <stop stopColor="#D9BB45" offset=".087%" />
            <stop stopColor="#6B5014" offset="100%" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g
            transform="translate(2.273 2.377)"
            stroke="#FFF"
            strokeLinejoin="round"
          >
            <path
              d="M12.7272727,-1.79096142 L26.7166791,18.9942217 L20.2819387,26.2459016 L5.17071875,26.2459016 L-1.26206297,18.9941166 L12.7272727,-1.79096142 Z"
              transform="matrix(1 0 0 -1 0 25.246)"
              fill="#32BE9C"
              strokeOpacity=".898"
              strokeWidth="2"
            />
            <polygon
              strokeOpacity=".503"
              fill="#9D781C"
              strokeLinecap="round"
              points="25.4545455 6.42622951 19.8323539 0 12.7272727 7.13454796e-16 12.7272727 6.37297453"
            />
            <polygon
              strokeOpacity=".503"
              fill="url(#a)"
              strokeLinecap="round"
              transform="matrix(-1 0 0 1 12.727 0)"
              points="12.7272727 6.42622951 7.10508115 0 4.23903337e-15 7.13454796e-16 1.41301112e-15 6.37297453"
            />
            <polygon
              strokeOpacity=".503"
              fill="url(#b)"
              strokeLinecap="round"
              points="8.33357922 0 5.93939394 6.42622951 12.7272727 6.42622951 12.7272727 0"
            />
            <polygon
              strokeOpacity=".503"
              fill="#DCC156"
              strokeLinecap="round"
              transform="matrix(-1 0 0 1 32.242 0)"
              points="15.2727273 0 12.7272727 6.42622951 19.5151515 6.42622951 19.5151515 0"
            />
            <polygon
              strokeOpacity=".503"
              fill="#825F14"
              strokeLinecap="round"
              transform="matrix(-1 0 0 1 38.182 0)"
              points="19.0909091 6.42622951 25.4545455 25.2459016 12.7272727 6.42622951"
            />
            <polygon
              strokeOpacity=".503"
              fill="url(#c)"
              strokeLinecap="round"
              points="6.36363636 6.42622951 12.7272727 25.2459016 -4.23903337e-15 6.42622951"
            />
            <polygon
              strokeOpacity=".503"
              fill="url(#d)"
              strokeLinecap="round"
              transform="matrix(-1 0 0 1 18.667 0)"
              points="5.93939394 6.42622951 5.93939394 25.2459016 12.7272727 6.42622951"
            />
            <polygon
              strokeOpacity=".503"
              fill="url(#e)"
              strokeLinecap="round"
              points="12.7272727 6.42622951 12.7272727 25.2459016 19.5151515 6.42622951"
            />
          </g>
          <polygon
            fill="#FFF"
            points="8 10.0342262 4.46446609 12.5355339 6.96577381 9 4.46446609 5.46446609 8 7.96577381 11.5355339 5.46446609 9.03422619 9 11.5355339 12.5355339"
          />
        </g>
      </svg>
    </div>
  );
}
